import { Button } from '@/components/ui/button'
import { Link } from 'react-router'
import { Upload, List, Layers } from 'lucide-react'

export function QuickActions() {
  return (
    <div className="flex flex-wrap gap-4">
      <Button asChild>
        <Link to="/upload">
          <Upload className="mr-2 h-4 w-4" />
          Upload File
        </Link>
      </Button>
      <Button variant="outline" asChild>
        <Link to="/runs">
          <List className="mr-2 h-4 w-4" />
          View All Runs
        </Link>
      </Button>
      <Button variant="outline" asChild>
        <Link to="/phenotypes">
          <Layers className="mr-2 h-4 w-4" />
          Browse Phenotypes
        </Link>
      </Button>
    </div>
  )
}
